/** @format */

import {
	Component,
	computed,
	effect,
	HostBinding,
	input,
	Signal,
	ViewEncapsulation
} from '@angular/core';
import {
	KillSwitches,
	MyCustomizerMap,
	ProcessedProduct,
	ProductStyle
} from '@shared/data-access/interfaces';
import { selectcustomProductData, selectLoadingProductImages } from '@pdp/data-access/state';

import { DynamicProductTemplateModules } from '@pdp/data-access/enums';
import { Store as NgRxStore } from '@ngrx/store';
import { Scene7MediaSetResponse } from '@shared/media/data-access';

@Component({
	selector: 'pdp-product-image-carousel',
	templateUrl: './product-image-carousel.component.html',
	encapsulation: ViewEncapsulation.None,
	standalone: false
})
export class ProductImageCarouselComponent {
	@HostBinding('class') classNames = '';

	lazyLoadImage = input(false);

	public location = input.required<DynamicProductTemplateModules | 'pdp_bundle_single_product'>();

	public product = input.required<ProcessedProduct | ProductStyle>();

	public chainIdentifierAbbr = input.required<string>();

	public killSwitches = input.required<KillSwitches>();

	public swatchColor = input<string>('');

	public mediaSet = input<Scene7MediaSetResponse>();

	// Customized URLs fetched from Custom Product Service on load
	public defaultCustomizedUrls = input<string[]>();

	// Computed
	available = computed(() => {
		const product = this.product();
		if (this.location() === DynamicProductTemplateModules.OUT_OF_STOCK_DEFAULT) {
			return 'skus' in product && !!product.skus;
		}
		return true;
	});

	catalogEntryTypeCode = computed(() => {
		if (this.location() === DynamicProductTemplateModules.BUNDLE_DEFAULT) {
			return 'BundleBean';
		}
		return 'ProductBean';
	});

	shouldHaveBorder = computed(
		() =>
			this.chainIdentifierAbbr() === 'pl' &&
			(this.location() === DynamicProductTemplateModules.IN_STOCK_DEFAULT ||
				this.location() === DynamicProductTemplateModules.CUSTOM_DEFAULT ||
				this.location() === DynamicProductTemplateModules.OUT_OF_STOCK_DEFAULT)
	);

	hasColorQueryParams = computed(() => {
		const product = this.product();
		if (!('defaultColor' in product)) {
			return false;
		}
		const selectedColorAttribute = product.defaultColor.replace(/[/ -]/g, '_');
		return !product.colorQueryParam || product.colorQueryParam === selectedColorAttribute;
	});

	customProductData: Signal<MyCustomizerMap | null> =
		this.ngrxStore.selectSignal(selectcustomProductData);
	customizedUrls = computed(
		() => this.customProductData()?.imageURLs ?? this.defaultCustomizedUrls()
	);

	loadingProductImages = this.ngrxStore.selectSignal(selectLoadingProductImages);

	constructor(private ngrxStore: NgRxStore) {
		effect(() => {
			switch (this.location()) {
				case DynamicProductTemplateModules.IN_STOCK_DEFAULT:
					this.classNames = 'hmf-pl-m-xs hmf-w-100';
					break;
				case DynamicProductTemplateModules.CUSTOM_DEFAULT:
					this.classNames = 'hmf-pl-m-xs';
					break;
				default:
					break;
			}
		});
	}
}
